import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RotatingCircleLoadingIndicator } from "Components/Shared";
import { TechnologyHighlightsConstants } from "Constants";
import { TechnologyHighlightsControllerSingleton } from "Controllers";
import { useFetch } from "Hooks";
import { FC, useContext, useEffect, useState } from "react";
import { CaseContext } from "Stores";
import { TGeneratedHighlightDTO, TGeneratedHighlightsDTO, TUseFetch } from "Types";

import styles from "./generatedTechnologyHighlights.module.scss";

type TGeneratedTechnologyHighlights = {
    dataType: string
}

export const GeneratedTechnologyHighlights: FC<TGeneratedTechnologyHighlights> = ({dataType}: TGeneratedTechnologyHighlights) => {
    // Contexts
    const { caseState } = useContext(CaseContext);

    // State
    const [generatedHighlights, setGeneratedHighlights] = useState<TGeneratedHighlightDTO[] | undefined>(undefined);

    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, fetchedData }: TUseFetch<TGeneratedHighlightsDTO>
        = useFetch(`api/technologies/${caseState.selectedTechnologyId}/highlights/generate?dataType=${dataType}`);

    useEffect(() => {
        if (fetchedData) {
            setGeneratedHighlights(fetchedData.result);
        }
    }, [fetchedData]);

    const onAcceptHighlightClick = async (highlight: TGeneratedHighlightDTO) => {
        if(!caseState.selectedCase || !caseState.selectedOriginalTechnologyId) return;
        if(!generatedHighlights) return;

        await TechnologyHighlightsControllerSingleton
            .createTechnologyHighlightAsync(caseState.selectedCase.id, caseState.selectedOriginalTechnologyId, 
                TechnologyHighlightsConstants.ALL_TECHNOLOGY_HIGHLIGHTS_GROUP_ID, highlight.highlight, true, highlight.paperId);

        setGeneratedHighlights(generatedHighlights.filter(generatedHighlight => generatedHighlight !== highlight));
    };

    const onDeclineHighlightClick = (highlight: TGeneratedHighlightDTO) => {
        if(!generatedHighlights) return;

        setGeneratedHighlights(generatedHighlights.filter(generatedHighlight => generatedHighlight !== highlight));
    };

    

    return (
        <div>
            {isLoading ?
                <RotatingCircleLoadingIndicator text="Generating highlights" />
                :
                <div>
                    {generatedHighlights && generatedHighlights.length > 0 ?
                        <div>
                            {generatedHighlights.map((highlight, index) => {
                                return (
                                    <div className={styles.generatedHighlight} key={`generated-highlight-${index}`}>
                                        <span>{highlight.highlight}</span>
                                        <div>
                                            <FontAwesomeIcon onClick={() => { onAcceptHighlightClick(highlight); }} className={styles.acceptTechnologyHighlight} icon={faCheck} />
                                            <FontAwesomeIcon onClick={() => { onDeclineHighlightClick(highlight); }} className={styles.declineTechnologyHighligt} icon={faTimes} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        :
                        <span>No highlights found</span> }
                </div>
            }
        </div>
    );
};